export enum MaintenanceType {
  MAINTENANCE = 'MAINTENANCE',
  CREEL_CHANGE = 'CREEL_CHANGE',
  MACHINE_UNAVAILABLE = 'MACHINE_UNAVAILABLE',
  WARP_CHANGE = 'WARP_CHANGE'
}
